export const lifecycleGate = {
label: {
draft: "Brouillon",
open: "Ouverte",
accepted: "Acceptée",
awaiting_assignee_response: "En attente d'acceptation",
assignee_declined: "Refusée par l'assigné",
scheduled: "Planifiée",
in_progress: "En cours",
paused: "En pause",
completion_submitted: "En attente de validation",
completion_rejected: "Reprise demandée",
completion_verified: "Validée",
awaiting_follow_on_approval: "En attente d'approbation",
cancelled: "Annulée",
skipped: "Ignorée",
},
shortLabel: {
draft: "Brouillon",
open: "Ouverte",
accepted: "Acceptée",
awaiting_assignee_response: "En attente",
assignee_declined: "Refusée",
scheduled: "Planifiée",
in_progress: "En cours",
paused: "En pause",
completion_submitted: "Soumise",
completion_rejected: "Reprise",
completion_verified: "Validée",
awaiting_follow_on_approval: "Approbation",
cancelled: "Annulée",
skipped: "Ignorée",
},
nextActor: {
draft: "{{name}} finalise le brouillon",
open: "{{name}} accepte l'intervention",
awaiting_assignee_response: "{{name}} accepte ou refuse",
assignee_declined: "{{name}} réattribue l'intervention",
scheduled: "{{name}} démarre le travail",
in_progress: "{{name}} soumet la fin des travaux",
paused: "{{name}} reprend une fois débloqué",
completion_submitted: "{{name}} examine la fin des travaux",
completion_rejected: "{{name}} effectue la reprise",
completion_verified: "L'intervention est clôturée",
awaiting_follow_on_approval: "{{name}} décide",
cancelled: "Aucune action supplémentaire",
skipped: "Aucune action supplémentaire",
},
nextActorYou: {
draft: "Vous finalisez le brouillon",
open: "Vous acceptez l'intervention",
awaiting_assignee_response: "Vous acceptez ou refusez",
assignee_declined: "Vous réattribuez l'intervention",
scheduled: "Vous démarrez le travail",
in_progress: "Vous soumettez la fin des travaux",
paused: "Vous reprenez une fois débloqué",
completion_rejected: "Vous effectuez la reprise",
completion_submitted: "Vous examinez la fin des travaux",
evidence_requested: "Vous ajoutez les preuves demandées et soumettez à nouveau",
awaiting_follow_on_approval: "Vous approuvez ou rejetez le suivi",
},
};
